import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Photo } from 'src/app/model/installation/photos.model';

export const APIUrls = {
  getBaseUrl: (): string =>
    (window as any).env?.gmaoApiUrl || 'http://localhost:8080/',

  getProxyUrl: (): string => APIUrls.getBaseUrl() + 'proxy/',
  getLoginUrl: (): string => APIUrls.getBaseUrl() + 'users/login/',
  getHomeUrl: (): string => APIUrls.getProxyUrl() + 'accueil/',
  getIncidentsUrl: (): string => APIUrls.getProxyUrl() + 'pannes/',
  getIncidentsSuiviUrl: (): string => APIUrls.getProxyUrl() + 'suivi/',
  getInstallationsUrl: (): string => APIUrls.getProxyUrl() + 'installations/',
  getStatsUrl: (): string => APIUrls.getBaseUrl() + 'api/stat/sales/',
  getMachinesSeriesUrl: (): string => APIUrls.getProxyUrl() + 'series/',
  getTotalSalesUrl: (): string => APIUrls.getProxyUrl() + 'sales/',
  getInstallationUrl: (): string => APIUrls.getProxyUrl() + 'install/',
  getContratUrl: (): string => APIUrls.getProxyUrl() + 'contract/',
  getApdSalesUrl: (): string => APIUrls.getProxyUrl() + 'apdsales/',
  getCallsUrl: (): string => APIUrls.getProxyUrl() + 'calls/',
  getCallsCountUrl: (): string => APIUrls.getProxyUrl() + 'callscount/',
  getInterventionsUrl: (): string => APIUrls.getProxyUrl() + 'interventions/',
  getPannesMachineUrl: (): string => APIUrls.getProxyUrl() + 'pannesmachine/',
  getPhotosUrl: (): string => APIUrls.getProxyUrl() + 'photos/',
  getCallsDetailsUrl: (): string => APIUrls.getProxyUrl() + 'calldetails/',
  getCallStateUrl: (): string => APIUrls.getBaseUrl() + 'sav/callstate/',
  getBreakdownSolverUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/breakdownsolver/',
  getStatusUrl: (): string => APIUrls.getBaseUrl() + 'checkstatus/',
  getApiVersionUrl: (): string => APIUrls.getBaseUrl() + 'checkstatus/version/',
  getIncidentsInstallationUrl: (): string =>
    APIUrls.getProxyUrl() + 'installationincidents/',
  getErrorsInstallationUrl: (): string =>
    APIUrls.getProxyUrl() + 'installationerrors/',
  getRateUrl: (): string => APIUrls.getBaseUrl() + 'api/rate/',
  getCallsStatsUrl: (): string => APIUrls.getBaseUrl() + 'sav/callslist/',
  getCodesPannesNbUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/callsoccurenceslist/',
  getInstallContractUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/installcontractslist/',
  getContractTypesUrl: (): string => APIUrls.getBaseUrl() + 'sav/contracts',
  getPannesStatsUrl: (): string => APIUrls.getBaseUrl() + 'sav/pannes',
  getPannesCodesUrl: (): string => APIUrls.getBaseUrl() + 'sav/pannescodes',
  getPannesStatsDetailsUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/pannesdetails',
  getMachineConnexionUrl: (): string => APIUrls.getBaseUrl() + 'api/apds/',
  getUsersListUrl: (): string => APIUrls.getBaseUrl() + 'users/list/',
  getUsersUrl: (): string => APIUrls.getBaseUrl() + 'users/',
  getSearchUrl: (): string => APIUrls.getProxyUrl() + 'search/',
  getPannesCategoriesUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/pannesCategories',
  getCodesPannesTableUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/codespannes',
  getTypesAppelsUrl: (): string => APIUrls.getBaseUrl() + 'sav/typeappels',
  getActionsSavUrl: (): string => APIUrls.getBaseUrl() + 'sav/actions',
  getIntervenantsSavUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/intervenants',
  getDepartementUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/departementsList',
  getIntervenantSavListUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/intervenantSavList',
  getInstallationsByDateUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/getIdInstallationsByDate/',
  getMachineUrl: (): string => APIUrls.getProxyUrl() + 'machine/',
  getMaterielUniteUrl: (): string => APIUrls.getProxyUrl() + 'materielunites/',
  getHistoInstallUrl: (): string => APIUrls.getProxyUrl() + 'histoinstall/',
  getInstallMesUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/installservicelist/',
  getInstallMesAndInstalleesUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/installationsInstalleesAndMES/',
  getInstallOwnerUrl: (): string => APIUrls.getBaseUrl() + 'sav/installowner/',
  getInstallNotConnectUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/installnotconnected/',
  getIncompleteBackupUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/incompletebackup/',
  getSalesNotInServiceUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/installssalesnotinservice/',
  getMaterielUrl: (): string => APIUrls.getProxyUrl() + 'materiel/',
  getMessagesUrl: (): string => APIUrls.getProxyUrl() + 'messages/',
  getMessageUrl: (): string => APIUrls.getProxyUrl() + 'message/',
  postMessageUrl: (): string => APIUrls.getProxyUrl() + 'updatemessage/',
  postCallUrl: (): string => APIUrls.getProxyUrl() + 'updatecall/',
  addInstallMessageUrl: (): string =>
    APIUrls.getProxyUrl() + 'addinstallmessage/',
  removeInstallMessageUrl: (): string =>
    APIUrls.getProxyUrl() + 'removeinstallmessage/',
  getInstallsMessageUrl: (): string =>
    APIUrls.getProxyUrl() + 'installsmessage/',
  deleteMessageUrl: (): string => APIUrls.getProxyUrl() + 'deletemessage/',
  getSalesTwoYearsUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/amountsalestwoyears/',
  postValidationUrl: (): string => APIUrls.getBaseUrl() + 'sav/postvalidation/',
  markAsDealUrl: (): string => APIUrls.getProxyUrl() + 'markasdeal/',
  getPeopleInstallListUrl: (): string => APIUrls.getProxyUrl() + 'peoplefor/',
  getPeopleListUrl: (): string => APIUrls.getProxyUrl() + 'people/',
  getAdpsBreakdownUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/apdsbreakdown/',
  getCheckInfosUrl: (): string => APIUrls.getBaseUrl() + 'sav/checkinfos/',
  getPersonneUrl: (): string => APIUrls.getProxyUrl() + 'personne/',
  getPannesOneYearUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/extractionpannes',
  getBreakdownSolverStatsUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/breakdownsolverstats',
  getAllBreakdownSolverUrl: (): string =>
    APIUrls.getBaseUrl() + 'sav/allbreakdownsolvers',
  getBreakdownByIdUrl: (): string => APIUrls.getProxyUrl() + 'breakdownsav/',
  getPhotoUrl: (): string => APIUrls.getBaseUrl() + 'photo/',
  getTreeUrl: (): string => APIUrls.getBaseUrl() + 'api/tree/',
  getCompagnyUrl: (): string =>
    APIUrls.getBaseUrl() + 'admin/?page=societes&controller=ajx&do=get&id=all',
  getCompagnyDetailUrl: (): string =>
    APIUrls.getBaseUrl() +
    'admin/?page=societes&controller=ajx&do=get&type=societe&id=',
  getCompagnyPersonsUrl: (): string =>
    APIUrls.getBaseUrl() +
    'admin/?page=societes&controller=ajx&do=get&type=societe_personne&id_lien=',
  getCompagnyInstallationsUrl: (): string =>
    APIUrls.getBaseUrl() +
    'admin/?page=societes&controller=ajx&do=get&type=societe_installations&id_societe=',
};

@Injectable({
  providedIn: 'root',
})
export class WebConfigurationService {
  /**
   * current active SAV server token
   */
  public static bearerToken: string;

  constructor(protected http: HttpClient) {}

  protected getContractsTypesUrl(): string {
    return APIUrls.getContractTypesUrl();
  }
  protected getMachinesSerieUrl(id: string): string {
    const url = APIUrls.getMachinesSeriesUrl();
    return url + id;
  }

  protected getTreeElementRootUrl(): string {
    return APIUrls.getTreeUrl() + 'composant/';
  }

  protected getTreeElementUrl(id: string): string {
    return this.getTreeElementRootUrl() + id;
  }

  protected getTreeComposantsUrl(ids: string[]): string {
    let url = APIUrls.getTreeUrl() + 'composants/?';
    for (let i = 0; i < ids.length; i++) {
      url += 'id[]=' + ids[i];
      if (i < ids.length - 1) {
        url += '&';
      }
    }
    return url;
  }

  protected getTreeElementsByChildrenTypeUrl(type: string): string {
    return APIUrls.getTreeUrl() + 'childrentype/' + type;
  }

  protected getTreeElementsByTypeUrl(type: string): string {
    return APIUrls.getTreeUrl() + 'type/' + type + '/orphans';
  }

  protected getTreeTypesUrl(): string {
    return APIUrls.getTreeUrl() + 'types';
  }
  protected getLoginUrl(): string {
    return APIUrls.getLoginUrl();
  }

  protected getTreeChildrenUrl(id: string): string {
    return APIUrls.getTreeUrl() + 'composant/' + id + '/children';
  }

  protected getInstallationUrl(id: string): string {
    return APIUrls.getInstallationUrl() + id;
  }

  protected getInterventionsUrl(id: string, p: string): string {
    return APIUrls.getInterventionsUrl() + id + '/' + p;
  }

  protected getCompanyUrl(id: string): string {
    return APIUrls.getCompagnyDetailUrl() + id;
  }

  protected getCompanyPersons(id: string): string {
    return APIUrls.getCompagnyPersonsUrl() + id;
  }

  protected getCompanyInstallationsUrl(id: string): string {
    return APIUrls.getCompagnyInstallationsUrl() + id;
  }

  protected getPannesMachineUrl(id: string): string {
    return APIUrls.getPannesMachineUrl() + id;
  }

  protected getCodesPannesStatsLastThirtyDays(codes: string[]) {
    let retour = APIUrls.getCallsStatsUrl() + 'codes/?code[]=';
    codes.forEach((code, index) => {
      if (index > 0) {
        retour += ',';
      }
      retour += code;
    });
    return retour;
  }

  protected getSearchUrl(search: string, page: string): string {
    return APIUrls.getSearchUrl() + search + '/' + page;
  }

  protected getCallSattsUrl(
    contractType: number,
    startDate: string,
    endDate: string,
    dateMiseEnService: string,
    action: string,
    intervenant: string,
    callType: string,
    codePanne: string,
    techniciens: number,
    departements: any,
    validation: any
  ) {
    let retour =
      APIUrls.getCallsStatsUrl() +
      '?startDate=' +
      startDate +
      '&endDate=' +
      endDate;

    if (contractType) {
      retour =
        APIUrls.getCallsStatsUrl() +
        '?startDate=' +
        startDate +
        '&endDate=' +
        endDate +
        '&contractType=' +
        contractType;
    }

    if (dateMiseEnService) {
      retour += '&dateModif=' + dateMiseEnService;
    }

    if (action && action !== 'Tous') {
      retour += '&action=' + action;
    }

    if (intervenant && intervenant !== 'Tous') {
      retour += '&intervenant=' + intervenant;
    }

    if (callType && callType !== 'Tous') {
      retour += '&callType=' + callType;
    }

    if (codePanne) {
      retour += '&codePanne=' + codePanne;
    }

    if (techniciens) {
      retour += '&techniciens=' + techniciens;
    }

    if (departements) {
      retour += '&departements=' + departements;
    }

    if (validation && validation != 'Tous') {
      retour += '&validation=' + validation;
    }

    return retour;
  }

  protected getMesInstall(mesDate: string) {
    let retour = APIUrls.getInstallMesUrl() + '?mesDate=' + mesDate;
    return retour;
  }

  protected getMesAndInstalleesListUrl(
    startDate: string,
    endDate: string
  ): string {
    return (
      APIUrls.getInstallMesAndInstalleesUrl() +
      '?startDate=' +
      startDate +
      '&endDate=' +
      endDate
    );
  }

  protected getcheckInfosUrl(): string {
    return APIUrls.getCheckInfosUrl();
  }

  protected getInstallContractsUrl(
    contractType: number,
    paramStart: string,
    startDate: string,
    paramEnd: string,
    endDate1: string,
    endDate2: string
  ) {
    let retour = APIUrls.getInstallContractUrl();

    if (startDate && !endDate1) {
      retour += '?paramStart=' + paramStart + '&startDate=' + startDate;
    } else if (startDate && endDate1 && !endDate2) {
      retour +=
        '?paramStart=' +
        paramStart +
        '&startDate=' +
        startDate +
        '&paramEnd=' +
        paramEnd +
        '&endDate1=' +
        endDate1;
    } else if (!startDate && endDate1 && !endDate2) {
      retour += '?paramEnd=' + paramEnd + '&endDate1=' + endDate1;
    } else if (startDate && endDate1 && endDate2) {
      retour +=
        '?paramStart=' +
        paramStart +
        '&startDate=' +
        startDate +
        '&paramEnd=' +
        paramEnd +
        '&endDate1=' +
        endDate1 +
        '&endDate2=' +
        endDate2;
    } else if (!startDate && endDate1 && endDate2) {
      retour +=
        '?paramEnd=' +
        paramEnd +
        '&endDate1=' +
        endDate1 +
        '&endDate2=' +
        endDate2;
    }
    if (contractType) {
      retour += '&contractType=' + contractType;
    }

    return retour;
  }

  protected getShortCallSattsUrl(
    codePanne: string,
    startDate: string,
    endDate: string
  ) {
    return (
      APIUrls.getCallsStatsUrl() +
      '?startDate=' +
      startDate +
      '&endDate=' +
      endDate +
      '&callType=Hotline&codePanne=' +
      codePanne
    );
  }

  protected getCodePannesNbUrl(
    codePanne: string,
    startDate: string,
    endDate: string
  ) {
    return (
      APIUrls.getCodesPannesNbUrl() +
      '?startDate=' +
      startDate +
      '&endDate=' +
      endDate +
      '&codePanne=' +
      codePanne
    );
  }

  protected getPanneStatsUrl(startDate: string, endDate: string): string {
    return (
      APIUrls.getPannesStatsUrl() +
      '?startDate=' +
      startDate +
      '&endDate=' +
      endDate
    );
  }

  protected getPanneStatsDetailsUrl(sDate: string, eDate: string): string {
    return (
      APIUrls.getPannesStatsDetailsUrl() +
      '?startDate=' +
      sDate +
      '&endDate=' +
      eDate
    );
  }

  protected getSalesUrl(
    startMonth: number,
    startYear: number,
    monthCount: number,
    idMachine: number,
    idBackUp: number
  ) {
    // console.error("DO ME I AM ISSUE #7, fix URL");
    // return SAV_BASE_URL +
    // 'admin/?page=ventes&controller=ajx&do=get&start_month='+startMonth+'&start_year='+startYear+'&months_count='+monthCount+'&id_machine='+idMachine+'&id_backup='+idBackUp;
    return (
      APIUrls.getProxyUrl() +
      '/machinesales/' +
      idMachine +
      '/' +
      idBackUp +
      '?startMonth=' +
      startMonth +
      '&startYear=' +
      startYear +
      '&monthsCount=' +
      monthCount
    );

    // /machinesales/idMachine/idBackup?startMonth=startMonth&startYear=startYear&monthsCount=monthsCount
  }

  protected getTotalSalesUrl(id: string): string {
    return APIUrls.getTotalSalesUrl() + id;
  }

  protected getDataChartsUrl(id: string): string {
    return APIUrls.getApdSalesUrl() + id;
  }

  protected getContratSavUrl(id: string): string {
    return APIUrls.getContratUrl() + id;
  }

  protected getPhotosUrl(id: string): string {
    return APIUrls.getPhotosUrl() + id;
  }

  protected getApdConnexionUrl(sn: string) {
    return APIUrls.getMachineConnexionUrl() + sn + '/connexion';
  }

  protected getPhotoUrl(photo: Photo): string {
    //console.error("I am hard-coded : 1 ");
    return (
      APIUrls.getPhotoUrl() + photo.filename + '/' + photo.original_filename
    );
  }

  protected getCallsDetailsUrl(id: string): string {
    return APIUrls.getCallsDetailsUrl() + id;
  }

  protected getCallStateUrl(id: string): string {
    return APIUrls.getCallStateUrl() + id;
  }

  protected getNomPrenomProprietaireUrl(id: number): string {
    return APIUrls.getPersonneUrl() + id;
  }

  protected getRaisonSocialeUrl(id: string): string {
    console.error('fix URL when DIVALTO UP');
    return (
      APIUrls.getBaseUrl() +
      'admin/?page=personnes&controller=ajx&do=get&type=personne_societes&id_personne=' +
      id
    );
  }

  protected getCallsListUrl(page: string): string {
    return APIUrls.getCallsUrl() + page;
  }

  protected getCodesPannesUrl(): string {
    return APIUrls.getPannesCodesUrl();
  }

  protected getCategoriesPannesUrl(): string {
    return APIUrls.getPannesCategoriesUrl();
  }

  protected getCodesPannesTableUrl(): string {
    return APIUrls.getCodesPannesTableUrl();
  }

  protected getTypesAppelsUrl(): string {
    return APIUrls.getTypesAppelsUrl();
  }

  protected getActionsSavUrl(): string {
    return APIUrls.getActionsSavUrl();
  }

  protected getIntervenantsSavUrl(): string {
    return APIUrls.getIntervenantsSavUrl();
  }

  protected getDepartementUrl(): string {
    return APIUrls.getDepartementUrl();
  }

  protected getIntervenantsSavListUrl(): string {
    return APIUrls.getIntervenantSavListUrl();
  }
  protected getPeopleInstallListUrl(id: number): string {
    return APIUrls.getPeopleInstallListUrl() + id;
  }
  protected getPeopleListUrl(): string {
    return APIUrls.getPeopleListUrl();
  }

  protected getIdInstallationsByDateUrl(sDate: string, eDate: string): string {
    return (
      APIUrls.getInstallationsByDateUrl() +
      '?startDate=' +
      sDate +
      '&endDate=' +
      eDate
    );
  }

  //getMachineUrl(), getMaterielUniteUrl() and getHistoInstallUrl() for machine page

  protected getMachineUrl(id: string): string {
    return APIUrls.getMachineUrl() + id;
  }

  protected getMaterielUniteUrl(id: string): string {
    return APIUrls.getMaterielUniteUrl() + id;
  }

  protected getHistoInstallUrl(id: string): string {
    return APIUrls.getHistoInstallUrl() + id;
  }

  protected getAdpsBreakdownUrl(
    startDate: string,
    endDate: string,
    serialNumber: string,
    subject: string,
    groupMode: string,
    beginServiceDate: string,
    endServiceDate: string,
    breakdownCode: string
  ) {
    return (
      APIUrls.getAdpsBreakdownUrl() +
      '?startDate=' +
      startDate +
      '&endDate=' +
      endDate +
      '&serialNumber=' +
      serialNumber +
      '&subject=' +
      subject +
      '&groupMode=' +
      groupMode +
      '&beginServiceDate=' +
      beginServiceDate +
      '&endServiceDate=' +
      endServiceDate +
      '&breakdownCode=' +
      breakdownCode
    );
  }

  /**
   * Format a date to a back-end friendly parameter
   * @param date a valid string representation of the date to format
   * @returns Date as ==> 2021-12-31
   */
  protected getFormattedDate(date: Date): string {
    let newDate = new Date(date);
    return (
      newDate.getFullYear() +
      '-' +
      (newDate.getMonth() + 1) +
      '-' +
      newDate.getDate()
    );
  }

  protected getUserUrl(login: string): string {
    return APIUrls.getUsersUrl() + login;
  }

  protected getMaterielUrl(id: string): string {
    return APIUrls.getMaterielUrl() + id;
  }

  protected getMessageUrl(id: string): string {
    return APIUrls.getMessageUrl() + id;
  }

  protected postValidationUrl(): string {
    return APIUrls.postValidationUrl();
  }

  protected getbreakdownsOneYearUrl(): string {
    return APIUrls.getPannesOneYearUrl();
  }
  protected getBreakdownSolverDataUrl(): string {
    return APIUrls.getBreakdownSolverStatsUrl();
  }
  protected getBreakdownAllBreakdownSolverUrl(): string {
    return APIUrls.getBreakdownSolverUrl();
  }
  protected getBreakdownDetailByIdUrl(id: string): string {
    return APIUrls.getBreakdownByIdUrl() + id;
  }

  public createHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + WebConfigurationService.bearerToken,
    });
  }

  /**
   * sends an authenticated GET request.
   * @param url requested URL
   * @param token a valid API token
   * @returns an Observable instance.
   */
  protected authGetObs<T>(url: string): Observable<T> {
    return this.http.get<T>(url, { headers: this.createHeaders() }); /*
      .pipe(
        catchError(this.handleError(error))
      );*/
  }

  protected authDelObs<T>(url: string): Observable<T> {
    return this.http.delete<T>(url, { headers: this.createHeaders() });
  }

  protected authPutObs<T>(url: string, body: any): Observable<T> {
    return this.http.put<T>(url, body, {
      headers: this.createHeaders().set('content-type', 'application/json'),
    });
  }

  private handleError(error: HttpErrorResponse | any) {
    if (error.status === 401) {
      // redirect to login page

      return;
    } else {
    }
    return throwError(error);
  }
}
